<div class="import-settings-container">
  <mat-label>{{ label | translate }}</mat-label>
  <!-- <app-icon name="question_circle_20_filled" class="grey" matTooltip="info"></app-icon> -->
  <mat-select id="upload_csv_list_{{settingType}}" [formControl]="formControl">
    <mat-option id="upload_{{settingType}}_list_option_{{option.value}}" *ngFor="let option of options" [value]="option?.apiValue">
      {{ option?.viewValue }}
    </mat-option>
  </mat-select>
</div>
